var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowto3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_4049)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.669 15.4189C29.0793 14.794 28.0607 14.794 27.471 15.4189L26.9032 16.0207C26.512 16.4352 25.9065 16.5919 25.3531 16.4217L24.5496 16.1747C23.7153 15.9182 22.8332 16.4099 22.6461 17.2358L22.5933 17.4691L24.3255 20.4694C25.4991 19.2822 27.1285 18.5466 28.9297 18.5466C32.5049 18.5466 35.4033 21.4449 35.4033 25.0202C35.4033 28.5955 32.5049 31.4938 28.9297 31.4938C25.4328 31.4938 22.5836 28.7213 22.4602 25.2545L19.5219 26.951C19.7387 27.2992 19.7961 27.7268 19.6644 28.1263L19.4085 28.902C19.1429 29.7076 19.6521 30.5593 20.5075 30.7399L21.3312 30.9138C21.8987 31.0337 22.3419 31.4616 22.466 32.0095L22.6461 32.8047C22.8332 33.6306 23.7153 34.1224 24.5496 33.8658L25.3531 33.6188C25.9065 33.4487 26.512 33.6053 26.9032 34.0199L27.471 34.6216C28.0607 35.2466 29.0793 35.2466 29.669 34.6216L30.2369 34.0199C30.6281 33.6053 31.2335 33.4487 31.787 33.6188L32.5904 33.8658C33.4247 34.1224 34.3068 33.6306 34.4939 32.8047L34.6741 32.0095C34.7982 31.4616 35.2414 31.0337 35.8088 30.9138L36.6325 30.7399C37.4879 30.5593 37.9972 29.7076 37.7315 28.902L37.4757 28.1263C37.2994 27.5919 37.4617 27.0074 37.891 26.6296L38.5143 26.0814C39.1616 25.512 39.1616 24.5285 38.5143 23.9592L37.891 23.4109C37.4617 23.0332 37.2994 22.4486 37.4757 21.9142L37.7315 21.1385C37.9972 20.333 37.4879 19.4813 36.6325 19.3006L35.8088 19.1267C35.2414 19.0069 34.7982 18.579 34.6741 18.0311L34.4939 17.2358C34.3068 16.4099 33.4247 15.9182 32.5904 16.1747L31.787 16.4217C31.2335 16.5919 30.6281 16.4352 30.2369 16.0207L29.669 15.4189Z",
    fill: "#0D5FDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9704 17.6743C13.9704 17.6743 10.3768 3.95827 6.81018 5.18506L3.63227 7.01983C0.786521 9.49522 10.8681 19.4654 10.8681 19.4654L12.4193 18.5698L13.9704 17.6743Z",
    fill: "url(#paint0_linear_75_4049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55298 25.0865C6.00069 24.13 6.32844 22.9068 7.28503 22.3545L18.1482 16.0826C19.1048 15.5304 20.3279 15.8581 20.8802 16.8147L22.2574 19.2C22.5335 19.6783 22.3697 20.2899 21.8914 20.566L9.29617 27.8379C8.81787 28.114 8.20628 27.9502 7.93014 27.4719L6.55298 25.0865Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.70166,
    y: 28.4326,
    width: 14.743,
    height: 1.90791,
    transform: "rotate(-30 9.70166 28.4326)",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9301 30.0535C31.7108 30.0535 33.9651 27.7992 33.9651 25.0184C33.9651 22.2377 31.7108 19.9834 28.9301 19.9834C26.1493 19.9834 23.895 22.2377 23.895 25.0184C23.895 27.7992 26.1493 30.0535 28.9301 30.0535ZM31.985 24.2867C32.34 23.8637 32.2849 23.2329 31.8619 22.8779C31.4388 22.5228 30.8081 22.5779 30.453 23.001L28.4678 25.3663L27.3512 24.242C26.9621 23.8501 26.3289 23.8479 25.937 24.237C25.5452 24.6262 25.543 25.2594 25.9321 25.6512L27.0487 26.7756C27.8774 27.6101 29.2437 27.5529 29.9997 26.6521L31.985 24.2867Z",
    fill: "#0D5FDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_4049",
    x1: 5.22123,
    y1: 6.10245,
    x2: 12.4193,
    y2: 18.5698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCFCF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_4049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowto3);
export default __webpack_public_path__ + "static/media/howto3.7049a8b5c9e3b1df46529bfef7c07866.svg";
export { ForwardRef as ReactComponent };